const getSilentBlockedEmailDomains = require("./getSilentBlockedEmailDomains");
const doesEmailContainOneOfDomains = require("./doesEmailContainOneOfDomains");

/**
 * @param email {string}
 * @return {boolean}
 */
module.exports = function shouldBlockEmailDomainSilently(email) {
    const silentBlockedEmailDomains = getSilentBlockedEmailDomains();
    return doesEmailContainOneOfDomains(email, silentBlockedEmailDomains);
}